import { selectModalMode } from './selectModalMode';
import { selectActiveFeature } from '../../../Map/selectors';
import { EListingModalMode } from '../../actions/listingModal';
import { IApplicationState } from '../../types/redux';

export const selectIsMapButtonVisible = (state: IApplicationState): boolean =>
  !selectActiveFeature(state) && selectModalMode(state) === EListingModalMode.FULL_SCREEN;
